import Constants from '@/Constants';
import { CourseType } from '@/models/CourseLessonContentTO';
import { ApplicationState } from '@/store';
import React from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import './style.scss';

interface Props {
    show: boolean;
    setShow: CallableFunction;
}

const ModalTypeOfTraining = ({ show, setShow }: Props) => {
    const history = useHistory();
    const match = useRouteMatch();
    const dispatch = useDispatch();

    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const handleTrainingCreation = (type: CourseType) => {
        switch (type) {
            case 'REGULAR':
                localStorage.setItem(Constants.TYPE_OF_TRAINING, 'REGULAR');
                break;
            case 'WORKSHOP':
                localStorage.setItem(Constants.TYPE_OF_TRAINING, 'WORKSHOP');
                break;
        }
        history.push(`${match.url}/`);
    };

    return (
        <Modal aria-labelledby="contained-modal-title-vcenter" centered show={show}>
            <Modal.Body>
                <div className="modal-type-of-training">
                    <i className="material-icons-outlined close-icon" onClick={() => setShow(false)}>
                        {Constants.icons.CLOSE}
                    </i>

                    <span className="modal-type-of-training__title">{strings.WHAT_TRAINING_DO_YOU_WANT_TO_CREATE}</span>

                    <div className="modal-type-of-training__card-button" onClick={() => handleTrainingCreation('REGULAR')}>
                        <i className="material-icons-outlined icon">{Constants.icons.PUBLIC}</i>
                        <span className="modal-type-of-training__title">{strings.COURSE_ONLINE}</span>
                    </div>

                    <span className="modal-type-of-training__button-explanation">{strings.TEXT_COURSE_ONLINE}</span>

                    <div className="modal-type-of-training__card-button" onClick={() => handleTrainingCreation('WORKSHOP')}>
                        <i className="material-icons-outlined icon">{Constants.icons.PEOPLE}</i>
                        <span className="modal-type-of-training__title">{strings.WORKSHOP}</span>
                    </div>

                    <span className="modal-type-of-training__button-explanation">{strings.TEXT_WORKSHOP}</span>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ModalTypeOfTraining;
